<template>
  <div :class="$style.container">
    <div :class="$style.intro">
      <img
        :class="$style.introImg"
        src="img/policyIntro.svg"
      >
      <p><strong>Create a policy and secure your fleet</strong></p>
      <p>
        Create policies to secure and manage the systems in your organization.
        <a
          :href="KbArticleUrls.gettingStartedPolicies"
          rel="noopener noreferrer"
          target="_blank"
        >
          Learn more
        </a>
      </p>
      <FlatActionButton
        :action="handleGetStarted"
        :buttonClass="['btnDefault', 'btnCTA']"
        text="get started"
      />
    </div>
  </div>
</template>

<script>
import { ItemTypeConsts, ItemTypeRoutes } from 'client/util/Constants';
import FlatActionButton from 'components/Buttons/FlatActionButton.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import Util from 'client/util/Util';

const { configuration } = ItemTypeConsts;

export default {
  name: 'SystemPoliciesIntro',

  components: {
    FlatActionButton,
  },

  props: {
    itemType: {
      type: String,
      default: configuration,
    },
  },

  data: () => ({
    KbArticleUrls,
  }),

  methods: {
    handleGetStarted() {
      const configurationRoute = ItemTypeRoutes[this.itemType];
      Util.redirect(configurationRoute);
    },
  },
};
</script>

<style module>
.container {
  height: 100%;
  overflow: auto;
  padding: 10px 20px 10px;
  width: 100%;
}

.intro {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.intro p {
  font-size: 14px;
}

.introImg {
  margin: 20px 0;
  max-width: 70%;
}
</style>
